import { TextField } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from './styles.module.css'
import { useContext, useState } from 'react';
import { RelatoriosContext } from '../RelatoriosContext';

const TabColunas = () => {
  const {dadosColunas, setDadosColunas} = useContext(RelatoriosContext)

  const handleAdd = () => {
    const allFieldsFilled = dadosColunas.every(item => item.nome && item.variavel && item.script);

    if (allFieldsFilled) {
      setDadosColunas([...dadosColunas, { nome: '', variavel: '$C{}', script: '' }]);
    } else {
      alert('Por favor, preencha todos os campos antes de adicionar uma nova linha.');
    }
  }

  const handleDelete = (index) => {
    const newList = [...dadosColunas];
    newList.splice(index, 1);
    setDadosColunas(newList);
  }

  const handleChange = (index, field, value) => {
    const newList = [...dadosColunas];
    newList[index][field] = value;
    setDadosColunas(newList);
  };
  return (
    <>
      <AddCircleOutlineIcon className={styles.add_button} onClick={handleAdd} />
      <div className={styles.container}>
        {dadosColunas.map((item, index) => {
          return (
            <div className={styles.row} key={item+index}>
              <TextField
                label='Nome'
                sx={{width: '25rem'}}
                value={item.nome}
                onChange={(e) => handleChange(index, 'nome', e.target.value)}
              />
              <TextField
                label='Variável'
                value={item.variavel}
                sx={{width: '20rem'}}
                onChange={(e) => handleChange(index, 'variavel', e.target.value)}
              />
              <TextField
                label='Script'
                value={item.script}
                sx={{width: '30rem'}}
                onChange={(e) => handleChange(index, 'script', e.target.value)}
              />
              <DeleteIcon className={styles.trash_button} onClick={() => handleDelete(index)} />
            </div>
          )
        })}
      </div>
    </>
  )
}

export default TabColunas